import { SearchTerm } from "./SearchTerm";

const DeviceEventActionSearch: SearchTerm[] = [
    {
        heading: "Name",
        accessor: "name",
        translationKey: "name",
        searchOnName: "setting.trnName",
    },
    {
        heading: "Type",
        accessor: "type",
        searchOnName: "setting.settingType.trnName",
        translationKey: "type"
    },
];

export default DeviceEventActionSearch;
